import './style.scss';

import jsPDF from 'jspdf';
import 'jspdf-autotable';


import seeds from "../../assets/images/logo_udea2.png";
import {getMeetingsAttendance} from "../../API/apiService";
import mayorLogo from '../../assets/images/medellin.png';

function PrintAttendance({school, meetingGroup}) {
    const baseURL = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_URI;

    async function getInfo() {
        return await getMeetingsAttendance(meetingGroup.id);
    }

    function generateHeader(doc) {

        const imageHeader = new Image();
        imageHeader.src = seeds;
        const imgHeight = 23;
        doc.addImage(
            imageHeader,
            'PNG',
            30, 27,
            90,
            imgHeight
        );

        const imageMayor = new Image();
        imageMayor.src = mayorLogo;
        doc.addImage(
            imageMayor,
            'PNG',
            531, 27,
            60,
            32
        );
        const tableY = 27;


        doc.autoTable({
            startY: tableY,
            body: [
                [{content: ''}, {
                    content: 'ASISTENCIA PROCESO FORMATIVO', styles: {
                        halign: 'center',
                        valign: "bottom",
                        cellPadding: 0, fontStyle: "bold",
                    }
                }, {
                    content: ''
                }],
                [{
                    content: ''
                },
                    {
                        content:
                            'CONTRATO INTERADMINISTRATIVO 4600104785 DE 2025',
                        styles: {
                            halign: 'center',
                            cellPadding: 0
                        }
                    },
                    {
                        content: ''
                    }
                ], [{
                    content: '',
                    styles: {
                        halign: 'center',
                        cellPadding: 0
                    }
                },
                    {
                        content: ''
                    }
                ],
            ],
            columnStyles: {
                0: {cellWidth: 150, halign: 'right'},
                1: {cellWidth: 189, halign: 'right'},
                2: {cellWidth: 123, halign: 'right'},
            },
            styles: {fontSize: 9},
            theme: 'plain',

        });
    }

    async function handleGeneratePDF() {
        console.log(meetingGroup);
        const group = school?.groups?.find(g => g.id === meetingGroup.group_id);
        const meetingDetail = await getInfo();

        const municipality = group?.municipality?.id ? `${group?.municipality?.id} - ${group?.municipality?.name}`
            : `${school?.municipality?.id} - ${school?.municipality?.name}`;
        const neighborhood = group?.neighborhood?.id ?  `${group?.neighborhood?.name}` : `${school?.neighborhood?.name}`;
        // eslint-disable-next-line new-cap
        const doc = new jsPDF('landscape', 'px', 'a4');
        doc.setDrawColor(204, 204, 204);
        doc.setLineWidth(0.6);
        doc.roundedRect(15, 15, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 30, 3, 3, 'S');
        const y = 71;
        const person = group?.user?.full_name ?? school.user?.full_name;
        let date = '';
        if (meetingGroup?.meeting_date) {
            const index = meetingGroup?.meeting_date?.indexOf('T');
            if (index !== -1) {
                date = meetingGroup?.meeting_date?.substring(0, index);
            }
        }

        generateHeader(doc);

        doc.autoTable({
            startY: y,
            body: [
                [{
                    content: 'Con la asistencia certifico haber recibido el refrigerio en el marco de la sesion que se nombra en el encabezado',
                    colSpan: 8,
                    styles: {
                        valign: 'middle',
                        cellPadding: 3,
                        lineWidth: 0.3,
                    }
                }
                ],
                [
                    {
                        content: 'COMUNA',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                            cellPadding: {left: 3}
                        }
                    },
                    {
                        content: `${municipality}`,
                        styles: {lineWidth: 0.3}
                    },
                    {
                        content: 'BARRIO',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                            cellPadding: {left: 3}
                        }
                    },
                    {
                        content: neighborhood,
                        styles: {lineWidth: 0.3}
                    },
                    {
                        content: 'ESCUELA',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                        }
                    },
                    {
                        content: `${school?.code}`,
                        styles: {lineWidth: 0.3}
                    },
                    {
                        content: 'GRUPO',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                        }
                    },
                    {
                        content: `${meetingGroup?.groupName}`,
                        styles: {lineWidth: 0.3}
                    },
                ],
                [
                    {
                        content: 'ENCUENTRO',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                            cellPadding: {left: 3}
                        }
                    },
                    {
                        content: `${meetingGroup?.meetingName}`,
                        styles: {lineWidth: 0.3}
                    },
                    {
                        content: 'DINAMIZADOR',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                            cellPadding: {left: 3}
                        }
                    },
                    {
                        content: `${person}`,
                        styles: {lineWidth: 0.3}
                    },
                    {
                        content: 'FECHA',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                        }
                    },
                    {
                        content: `${date}`,
                        styles: {lineWidth: 0.3}
                    },
                    {
                        content: 'SESION',
                        styles: {
                            valign: 'middle',
                            fontStyle: "bold",
                            lineWidth: 0.3,
                        }
                    },
                    {
                        content: `${meetingGroup?.order}`,
                        styles: {lineWidth: 0.3}
                    },
                ]
            ],
            columnStyles: {
                0: {cellWidth: 57, halign: 'left', cellPadding: 0},
                1: {cellWidth: 90, halign: 'left', lineWidth: 0.3},
                2: {cellWidth: 54, halign: 'left'},
                3: {cellWidth: 147, halign: 'left'},
                4: {cellWidth: 51, halign: 'left'},
                5: {cellWidth: 66, halign: 'left'},
                6: {cellWidth: 48, halign: 'left'},
                7: {cellWidth: 54, halign: 'left'}
            },

            styles: {fontSize: 9},
            theme: 'plain',
            margin: {top: 30, right: 30, bottom: 20, left: 30},
        });
        let data = [];
        if (meetingDetail) {
            console.log(meetingDetail)
            data = meetingDetail.attendances.map((a, index) => {
                const row = [];
                row.push(`${index + 1}`);
                row.push(a.beneficiary?.document_type);
                row.push(a.beneficiary?.document);
                row.push(a.beneficiary?.full_name);
                row.push(a.attended ? 'SI' : 'NO');
                row.push(a.attended && a.image ? a.image.id : null); // FOR IMAGE
                return row
            })
        }


        const tableHeaders = ['No', 'TIPO ID', 'IDENTIFICACION', 'NOMBRE COMPLETO', 'ASISTE', 'IMAGEN'];

        doc.autoTable({
            startY: 120,
            head: [tableHeaders],
            body: data,
            didDrawCell: data => {
                if (data.column.dataKey === 2 && data.cell.section === 'body') {
                    const rowHeight = 15;
                    const imgHeight = 30; // Set the height of the image
                    const imgWidth = 30;  // Set the width of the image
                    const imgX = 522;
                    const imgY = data.cell.y + 9 + (rowHeight - imgHeight) / 2; // Center the image vertically */

                    if (data.row.index < data.table.body.length) {
                        // Check if there is enough space for the image
                        const imageId = data.row.raw[5];
                        data.row.raw[5] = '';
                        if (imageId) {
                            const attendanceImage = new Image();
                            attendanceImage.src = `${baseURL}/image?imageId=${imageId}`;
                            doc.addImage(attendanceImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
                        }
                    }
                }
            },
            columnStyles: {
                0: {cellWidth: 45, halign: 'middle'},
                1: {cellWidth: 45, halign: 'middle'},
                2: {cellWidth: 99, halign: 'left'},
                3: {cellWidth: 230, halign: 'left'},
                4: {cellWidth: 48, halign: 'middle'},
                5: {cellWidth: 99, halign: 'left'},
            },
            styles: {fontSize: 9, lineWidth: 0.3, rowHeight: 40},
            theme: 'plain',
        });

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open the URL in a new window
        window.open(pdfUrl, '_blank');
    }


    return (
        <button className='generate-pdf' onClick={handleGeneratePDF} title={'Generar PDF'}>
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18V6L10 0ZM5.498 14.19C5.189 14.48 4.733 14.61 4.202 14.61C4.09904 14.6111 3.99613 14.6051 3.894 14.592V16.018H3V12.082C3.40345 12.0218 3.81112 11.9944 4.219 12C4.776 12 5.172 12.106 5.439 12.319C5.693 12.521 5.865 12.852 5.865 13.242C5.864 13.634 5.734 13.965 5.498 14.19ZM9.305 15.545C8.885 15.894 8.246 16.06 7.465 16.06C6.997 16.06 6.666 16.03 6.441 16V12.083C6.8446 12.0241 7.25214 11.9963 7.66 12C8.417 12 8.909 12.136 9.293 12.426C9.708 12.734 9.968 13.225 9.968 13.93C9.968 14.693 9.689 15.22 9.305 15.545ZM13 12.77H11.468V13.681H12.9V14.415H11.468V16.019H10.562V12.03H13V12.77ZM10 7H9V2L14 7H10Z"
                    fill="#EA5455"/>
            </svg>
        </button>
    );
};

export default PrintAttendance;